"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontPageFooter = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const Icon_1 = require("../../../Icon");
require("./index.scss");
const className = 'front-page-footer';
const FrontPageFooter = (props) => {
    const { modificators } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: `${className}__container` },
            react_1.default.createElement("div", { className: `${className}__company` }, "\u00A9 2009 - 2023 Malesia Reisen GmbH"),
            react_1.default.createElement("div", { className: `${className}__middle` },
                react_1.default.createElement("a", { className: `${className}__email`, href: 'mailto:info@malesiareisen.com' },
                    react_1.default.createElement("span", { className: `${className}__email-icon` },
                        react_1.default.createElement(Icon_1.Icon, { name: 'email' })),
                    react_1.default.createElement("span", { className: `${className}__email-text` }, "info@malesiareisen.com"))),
            react_1.default.createElement("div", { className: `${className}__social` },
                react_1.default.createElement("a", { className: `${className}__social-link`, href: 'https://www.facebook.com/malesiareisencom/' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'facebook' })),
                react_1.default.createElement("a", { className: `${className}__social-link`, href: 'https://www.instagram.com/MALESIAREISEN/' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'instagram' })),
                react_1.default.createElement("a", { className: `${className}__social-link`, href: 'https://www.youtube.com/channel/UCtLg7yvgUCE6nPFVqkiv8Aw/videos' },
                    react_1.default.createElement(Icon_1.Icon, { name: 'youtube' }))))));
};
exports.FrontPageFooter = FrontPageFooter;
//# sourceMappingURL=index.js.map